import React from 'react';
import Button from "../../../../../../core/components/button";
import {useAcceptNotification} from "../../../../api";
import handleError from "../../../../../../core/helper/handelError";

export default function AcceptBtn({notification,refecth,data}) {
    const {mutate:accept, isPending} = useAcceptNotification()
    const handleClick = () =>{
        accept(
            {id: notification?.id},
            {
                onSuccess: ()=>{
                    refecth()
                },
                onError: (error) =>{
                    handleError(error)
                    refecth()
                }
            }
        )
    }

    return (
        <>
            <Button size="sm" scale="fit" onClick={handleClick} isLoading={isPending}>
                {data?.title}
            </Button>
        </>
    );
}